import URL from '../api_url';

export const BEHAVIOR_ABC_API = `${URL}/abc-behavior`;

export const BEHAVIORS_ABC_API = `${URL}/abc-behaviors`;
